<div class="container-fluid">
    <div class="row">
        <!-- Header -->
        <div class="col-12 col-md-12 bgWhite padHeder mobView">
            <div class="col-12 col-md-6 pad0" style="display: inline-block;vertical-align: sub;">
                <!-- <span style="font-size: 20px; margin-right: 10px;" (click)="backBtn()">
                    <i class="fa fa-chevron-left"></i>
                </span> -->
                <h4 style="display: inline-block;">Settings</h4>
                <span class="btn-blue brdrRadius3"
                    style="margin-right: 15px !important; float: right; position: relative; padding: 2px 9px; top: 1px;"
                    (click)="backBtn()">
                    <i class="zmdi zmdi-arrow-left" style="margin-right: 5px;"></i>Back
                </span>
            </div>
        </div>

        <div class="col-12 col-sm-12 bgWhite webView" style="padding: 15px 15px 15px 30px">
            <div class="com-md-9 col-lg-9" style="display: inline-block; padding: 0px;">
                <h3 class="lblHeader newHeader" style="display: inline-block;">
                    Settings
                </h3>
            </div>
            <div class="com-md-3 col-lg-3" style="display: inline-block; text-align: right; padding: 0px;">
                <span class="btn-blue brdrRadius3"
                    style="font-size: 13px; display: inline-block; padding: 4px 12px 4px;" (click)="backBtn()">
                    <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
                </span>
            </div>
        </div>
        <!--New UI-->
        <div class="col-md-12 col-12 col-sm-12 leftPad">
            <!--Store & Rights-->
            <div class="col-md-3 col-12 col-sm-12 width25 padLft0">
                <div class="row padZero alignClass" style="margin: 0px;">
                    <div class="dashBox dashBox-stats brdrRadius3" style="margin-top: 10px;" (click)="redirect(1)">
                        <div class="dashBox-coloured-header brdrRadius3 gradDrkBlueBkgd">
                            <h3 class="dashBox-title ellipsis" style="font-size: 17px;">Stores & Rights</h3>
                        </div>
                        <div>
                            <p class="dashBox-category overrideDescriptionBottomCard reportDesc"
                                style="line-height: 22px;">Configure stores and control the accessibility by giving
                                rights.</p>
                        </div>
                    </div>
                </div>
            </div>
            <!--Categories-->
            <div class="col-md-3 col-12 col-sm-12 width25 padLft0">
                <div class="row padZero alignClass" style="margin: 0px;">
                    <div class="dashBox dashBox-stats brdrRadius3" style="margin-top: 10px;" (click)="redirect(2)">
                        <div class="dashBox-coloured-header brdrRadius3 gradDrkBlueBkgd">
                            <h3 class="dashBox-title ellipsis" style="font-size: 17px;">Categories</h3>
                        </div>
                        <div>
                            <p class="dashBox-category overrideDescriptionBottomCard reportDesc"
                                style="line-height: 22px;">Add and update categories as well as sub-categories for the
                                inventory items.</p>
                        </div>
                    </div>
                </div>
            </div>
            <!--Units-->
            <div class="col-md-3 col-12 col-sm-12 width25 padLft0">
                <div class="row padZero alignClass" style="margin: 0px;">
                    <div class="dashBox dashBox-stats brdrRadius3" style="margin-top: 10px;" (click)="redirect(3)">
                        <div class="dashBox-coloured-header brdrRadius3 gradDrkBlueBkgd">
                            <h3 class="dashBox-title ellipsis" style="font-size: 17px;">Units</h3>
                        </div>
                        <div>
                            <p class="dashBox-category overrideDescriptionBottomCard reportDesc"
                                style="line-height: 22px;">Configure units and precision for inventory items.</p>
                        </div>
                    </div>
                </div>
            </div>
            <!--Valuation-->
            <div class="col-md-3 col-12 col-sm-12 width25 padLft0">
                <div class="row padZero alignClass" style="margin: 0px;">
                    <div class="dashBox dashBox-stats brdrRadius3" style="margin-top: 10px;" (click)="open(mymodal, '')">
                        <div class="dashBox-coloured-header brdrRadius3 gradDrkBlueBkgd">
                            <h3 class="dashBox-title ellipsis" style="font-size: 17px;">Valuation</h3>
                        </div>
                        <div>
                            <p class="dashBox-category overrideDescriptionBottomCard reportDesc"
                                style="line-height: 22px;">Select the valuation mode.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-12 col-12 col-sm-12 leftPad">
            <!--HSN / SAC-->
            <div class="col-md-3 col-12 col-sm-12 width25 padLft0">
                <div class="row padZero alignClass" style="margin: 0px;">
                    <div class="dashBox dashBox-stats brdrRadius3" style="margin-top: 10px;" (click)="redirect(5)">
                        <div class="dashBox-coloured-header brdrRadius3 gradDrkBlueBkgd">
                            <h3 class="dashBox-title ellipsis" style="font-size: 17px;">HSN / SAC</h3>
                        </div>
                        <div>
                            <p class="dashBox-category overrideDescriptionBottomCard reportDesc"
                                style="line-height: 22px;"> Add HSN/SAC code for the inventory items.</p>
                        </div>
                    </div>
                </div>
            </div>
             <!-- Print Cofiguration -->
             <div class="col-md-3 col-12 col-sm-12 width25 padLft0">
                <div class="row padZero alignClass" style="margin: 0px;">
                    <div class="dashBox dashBox-stats brdrRadius3" style="margin-top: 10px;" (click)="openPrntCnfgMdl('prntCnfgMdl')">
                        <div class="dashBox-coloured-header brdrRadius3 gradDrkBlueBkgd">
                            <h3 class="dashBox-title ellipsis" style="font-size: 17px;">BOM Print Configuration</h3>
                        </div>
                        <div>
                            <p class="dashBox-category overrideDescriptionBottomCard reportDesc"
                                style="line-height: 22px;">Configure print settings for BOM details.</p>
                        </div>
                    </div>
                </div>
            </div>   
        </div>

        <!-- Manufacuring Cards  -->
         <div class="col-md-12 col-12 col-sm-12 leftPad" style="margin-top: 10px;">
            <div class="divHeaderForCard padZero" style="color: #15304a;">
                <span>Manufacturing</span>
            </div>
            <!-- Cards -->
            <div class="col-md-12 col-12 col-sm-12 pad0">
                <!-- Stage Flow -->
                <div *ngIf="rights.InvCfg && rights.PrdCfg" class="col-md-3 col-12 col-sm-12 width25 padLft0">
                    <div class="row padZero alignClass" style="margin: 0px;">
                        <div class="dashBox dashBox-stats brdrRadius3" style="margin-top: 10px;"
                            (click)="open(stageFlowMdl, 'stageFlow')">
                            <div class="dashBox-coloured-header brdrRadius3 gradDrkBlueBkgd">
                                <h3 class="dashBox-title ellipsis" style="font-size: 17px;">Stage Flow</h3>
                            </div>
                            <div>
                                <p class="dashBox-category overrideDescriptionBottomCard reportDesc"
                                    style="line-height: 22px;">
                                    Configure the stage flow for the inventory items.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Production Stages -->
                <div *ngIf="rights.PrdCfg" class="col-md-3 col-12 col-sm-12 width25 padLft0">
                    <div class="row padZero alignClass" style="margin: 0px;">
                        <div class="dashBox dashBox-stats brdrRadius3" style="margin-top: 10px;" [routerLink]="['/StageConfig']">
                            <div class="dashBox-coloured-header brdrRadius3 gradDrkBlueBkgd">
                                <h3 class="dashBox-title ellipsis" style="font-size: 17px;">Production Stages</h3>
                            </div>
                            <div>
                                <p class="dashBox-category overrideDescriptionBottomCard reportDesc"
                                    style="line-height: 22px;">
                                    Configure and manage the stages involved in the production process.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


         </div>


        <!-- settings List old UI-->
        <div class="col-md-12 col-12 col-sm-12 leftPad" style="display:none;">
            <div class="col-md-4 col-12 col-sm-12 mobshdred" style="padding: 10px; ">
                <div class="col-md-12 col-12 col-sm-12 orangeBadge brd"
                    style="border: 1px solid; padding-top: 10px; padding-bottom: 10px; cursor: pointer; margin-bottom: 10px;display:inline-flex">
                    <div (click)="redirect(1)" class="col-md-12 col-12 col-sm-12"
                        style="font-size: 13px;display: inline-block;padding: 0px;">
                        <div class="col-md-1 col-1 col-sm-1 inblk" style="padding: 0px;text-align: center;">
                            <span style="margin-right: 5px;"><i class="zmdi zmdi-store"></i></span>
                        </div>
                        <div class="col-md-11 col-11 col-sm-11 inblk" style="padding: 0px;">
                            <span>Stores & Rights 11</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-12 col-sm-12 yellowBadge brd"
                    style="border: 1px solid; padding-top: 10px; padding-bottom: 10px; cursor: pointer; margin-bottom: 10px;display:inline-flex">
                    <div (click)="redirect(2)" class="col-md-12 col-12 col-sm-12"
                        style="font-size: 13px;display: inline-block;padding: 0px;">
                        <div class="col-md-1 col-1 col-sm-1 inblk" style="padding: 0px;text-align: center;">
                            <span style="margin-right: 5px;"><i class="fa fa-sitemap"></i></span>
                        </div>
                        <div class="col-md-11 col-11 col-sm-11 inblk" style="padding: 0px;">
                            <span>Categories</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-12 col-sm-12 greenBadge brd"
                    style="border: 1px solid; padding-top: 10px; padding-bottom: 10px; cursor: pointer; margin-bottom: 10px;display:inline-flex">
                    <div (click)="redirect(3)" class="col-md-12 col-12 col-sm-12"
                        style="font-size: 13px;display: inline-block;padding: 0px;">
                        <div class="col-md-1 col-1 col-sm-1 inblk" style="padding: 0px;text-align: center;">
                            <span style="margin-right: 5px;"><i class="fa fa-balance-scale"
                                    aria-hidden="true"></i></span>
                        </div>
                        <div class="col-md-11 col-11 col-sm-11 inblk" style="padding: 0px;">
                            <span>Units</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-12 col-sm-12 tealBadge brd"
                    style="border: 1px solid; padding-top: 10px; margin-bottom: 10px; cursor: pointer;display:inline-flex">
                    <div (click)="redirect(4)" class="col-md-12 col-12 col-sm-12"
                        style="font-size: 13px;display: inline-block;padding: 0px;">
                        <div class="col-md-1 col-1 col-sm-1 inblk" style="padding: 0px;text-align: center;">
                            <span><i class="fa fa-rupee"></i></span>
                        </div>
                        <div class="col-md-11 col-11 col-sm-11 inblk" style="padding: 0px;" (click)="open(mymodal, '')">
                            <span>Valuation</span>
                        </div>
                    </div>
                </div>

                <div *ngIf="isIndian" class="col-md-12 col-12 col-sm-12 blueBadge brd"
                    style="border: 1px solid; display: none; padding-top: 10px; padding-bottom: 10px; cursor: pointer;display : inline-flex">
                    <div (click)="redirect(5)" class="col-md-12 col-12 col-sm-12"
                        style="font-size: 13px;display: inline-block;padding: 0px;">
                        <div class="col-md-1 col-1 col-sm-1 inblk" style="padding: 0px;text-align: center;">
                            <span><i class="fa fa-code" aria-hidden="true"></i></span>
                        </div>
                        <div class="col-md-11 col-11 col-sm-11 inblk" style="padding: 0px;">
                            <span>HSN / SAC</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Valuation-->
<ng-template #mymodal let-modal>
    <!--Header-->
    <div class="modal-header" style="border-bottom: none;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row">
                <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                    <h4 class="modal-title"><span id="ApntmntHdr">Valuation</span></h4>
                </div>
                <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="closeModal()"></i>
                </div>
            </div>
        </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">
        <div class="col-md-12" style="padding: 0px 15px 15px 15px; margin-top: 7px !important;">
            <div (click)="selectValuation(1, 'Standerd Cost')" title="Select Valuation"
                class="col-md-12 col-12 col-sm-12 {{isSelectedStanderd ? 'orangeButton' : 'orangeBrdr'}} brdrRadius3"
                style="padding-top: 7px !important; padding-bottom: 7px !important; margin-bottom: 5px;display:inline-flex;cursor: pointer;">
                <div class="col-md-10 col-10 col-sm-10"
                    style="font-size: 13px; display: inline-block;padding: 0px; text-align: left !important;">
                    <span>Standard Cost</span>
                </div>
                <div class="col-md-2 col-2 col-sm-2" style="text-align: right;display: inline-block;padding: 0px;">
                    <div *ngIf="isSelectedStanderd" style="font-size: 13px;">
                        <i class="fa fa-check" aria-hidden="true"></i>
                    </div>
                </div>
            </div>
            <div (click)="selectValuation(2,'Last Purchase Price')" title="Select Valuation"
                class="col-md-12 col-12 col-sm-12 {{isSelectedLPP ? 'orangeButton' : 'orangeBrdr'}} brdrRadius3"
                style="padding:8px 8px !important; margin-top: 10px; margin-bottom: 5px;display:inline-flex;cursor: pointer;">
                <div class="col-md-10 col-10 col-sm-10"
                    style="font-size: 13px;display: inline-block;padding: 0px; text-align: left !important;">
                    <span>Last Purchase Price</span>
                </div>
                <div class="col-md-2 col-2 col-sm-2" style="text-align: right;display: inline-block;padding: 0px;">
                    <div *ngIf="isSelectedLPP" style="font-size: 13px;">
                        <i class="fa fa-check" aria-hidden="true"></i>
                    </div>
                </div>
            </div>
            <div (click)="selectValuation(3,'Historical Average')" title="Select Valuation"
                class="col-md-12 col-12 col-sm-12 {{isSelectedHistorical ? 'orangeButton' : 'orangeBrdr'}} brdrRadius3"
                style="padding-top: 7px !important; padding-bottom: 7px !important;margin-top: 10px; margin-bottom: 5px;display:inline-flex;cursor: pointer;">
                <div class="col-md-10 col-10 col-sm-10"
                    style="font-size: 13px;display: inline-block;padding: 0px; text-align: left !important;">
                    <span>Historical Average</span>
                </div>
                <div class="col-md-2 col-2 col-sm-2" style="text-align: right;display: inline-block;padding: 0px;">
                    <div *ngIf="isSelectedHistorical" style="font-size: 13px;">
                        <i class="fa fa-check" aria-hidden="true"></i>
                    </div>
                </div>
            </div>

        </div>
    </div>
</ng-template>

<!--Valuation-->
<ng-template #stageFlowMdl let-modal>
    <!--Header-->
    <div class="modal-header" style="border-bottom: none; padding-bottom: 20px;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row" style="display: flex; justify-content: space-between;">
                <h4 class="modal-title" style="font-size: 22px;"><span id="ApntmntHdr">Stage Flows</span></h4>
                <div class="pad0" style="display: flex; flex-wrap: wrap; align-items: center; justify-content: end;">
                    <span class="btn-darkGreen brdrRadius3" (click)="openAddStageFlow(AddStageFlowMdl, 0)"
                        style="padding: 4px 8px !important; line-height: 17px; vertical-align: center !important; margin-right: 5px;background-color: #e88421; border-color: #e88421 !important; font-size: 14px;">
                        <i class="zmdi zmdi-plus" aria-hidden="true"></i> Add
                    </span>                   
                    <i class="closeMdl zmdi zmdi-close" style="float: right; margin: 0px; top: 0px;"
                        (click)="closeModal()"></i>
                </div>
            </div>
        </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">
        <div class="col-md-12 col-12 col-sm-12" style="padding: 0px 15px 15px 15px;">
            <!-- Stage List -->
            <div *ngIf="stgFlowList.length > 0" class="col-md-12 col-12 col-sm-12 pad0 marginTp"
                style="margin-bottom: 15px;">
                <!-- <div class="label-new" style="color: #333; font-size: 12px;">Current Stage Flows:</div> -->
                <div style="max-height: 200px; overflow-y: auto;">
                    <div mat-cell *ngFor="let s of stgFlowList; let i = index"
                        style="{{ i % 2 == 0 ? 'background-color: #f5f5f5;' : 'background-color: #fff;' }}">
                        <div class="col-md-12 col-12 col-sm-12 pad0"
                            style="display: flex; justify-content: space-between; align-items: center; padding: 5px 15px;">
                            <div class="col-md-9 col-9 col-sm-9 pad0 inLneBlk" style="font-size: 14px;">
                                <span>{{s.StageFlow}}</span>
                            </div>
                            <div class="col-md-1 col-1 col-sm-1 pad0 inLneBlk txtRight" (click)="editStageFlow(AddStageFlowMdl, i)">
                                <span class="lableBtnOrange height30 brdrRadius3" title="Edit Stage Flow Details"
                                    style="padding: 2px 7px 2px; "><i class="fa fa-pencil"></i></span>
                            </div>
                            <div class="col-md-1 col-1 col-sm-1 pad0 inLneBlk txtRight" (click)="removeStageFlow(i)">
                                <span class="lableBtnGray brdrRadius3" title="Remove Stage Flow"
                                    style="padding: 2px 7px 2px;"><i class="fa fa-trash-o"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="stgFlowList.length == 0">
                <div class="nrf brdrRadius3 mt-2" style="cursor: pointer;" (click)="openAddStageFlow(AddStageFlowMdl, 0)">
                    Click here to add a stage to your process flow.
                </div>
            </div>
        </div>
       
        
    </div>
</ng-template>
<ng-template #AddStageFlowMdl let-modal>
    <!--Header-->
    <div class="modal-header" style="border-bottom: none;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row" style="display: flex; justify-content: space-between;">
                <h4 class="modal-title" style="font-size: 22px;"><span id="ApntmntHdr">Stage Flow Configuration</span></h4>
                <div class="pad0" style="display: flex; flex-wrap: wrap; align-items: center; justify-content: end;">
                
                    <i class="closeMdl zmdi zmdi-close" style="float: right; margin: 0px; top: 0px;"
                        (click)="closeStageModal()"></i>
                </div>
            </div>
        </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">  
        <div class="col-md-12 col-sm-12 col-xs-12" style="padding: 0px 18px 18px 18px;">
            <div class="row m-0 p-0" style="display: flex !important; align-items: center !important;">
                <div class="label-new col-md-3 col-sm-3 col-xs-3 col-12 d-flex align-items-center" style="color: #333; font-size: 12px; ">
                    Flow Name <span class="smDsply">:</span>
                    <span class="redText margTop10">*</span>
                </div>
                <div class="col-md-9 col-sm-9 col-xs-9 col-12 m-0 p-0">
                    <input type="text" class="form-control form-control-input" [(ngModel)]="stgFlowName" tabindex="1"
                        capitalize-first maxlength="100" placeholder="Enter Flow Name">
                </div>        
            </div>
        
            <div>
                <div class="row m-0 p-0" style="margin-top: 15px !important;">
                    <div class="col-12 col-md-3 col-sm-3 col-xs-3 d-flex align-items-center m-0 p-0">
                        <div class="label-new" style="color: #333; font-size: 12px;">
                            Stage <span class="smDsply">:</span>
                            <span class="redText margTop10">*</span>
                        </div>
                    </div>
                    <!-- All Stages -->
                    <div class="col-12 col-md-9 col-sm-9 col-xs-9 m-0 p-0">
                        <select class="form-control form-control-input" (change)="addNewStage($event)" style="font-size: 13px;">
                            <option value="" selected>Select</option>
                            <option *ngFor="let s of stageList" [ngValue]="s.SNm">{{s.SNm}}</option>
                        </select>
                    </div>
                </div>
        
                <!-- Stage List -->
                <div class="col-md-12 col-12 col-sm-12 pad0 mt-3" style="margin-bottom: 15px;">
                    <div class="marginTp" *ngIf="newStageList.length > 0">
                        <div cdkDropList id="divScrID" (cdkDropListDropped)="drop($event)"
                            style="max-height: 200px; overflow-y: auto;">
                            <div *ngFor="let s of newStageList; let i = index"
                                style="cursor: pointer; {{ i % 2 == 0 ? 'background-color: #f5f5f5;' : 'background-color: #fff;' }}"
                                cdkDrag>
                                <div class="col-md-12 col-12 col-sm-12 pad0"
                                    style="display: flex; justify-content: space-between; align-items: center; padding: 5px 15px;">
                                    <div class="col-md-9 col-9 col-sm-9 pad0 inLneBlk" style="font-size: 14px;">
                                        <span> {{s.SNm}}</span>
                                    </div>
                                    <div class="col-md-1 col-1 col-sm-1 pad0 inLneBlk txtRight"
                                        style="display: inline-block; cursor: pointer;text-align: center; color: grey;"
                                        title="Rearrange Stage" (cdkDropListDropped)="drop($event)">
                                        <span class="brdrRadius3" style="color: #e88421;" title="Remove Stage">
                                            <i class="fa fa-bars"></i>
                                        </span>
                                    </div>
                                    <div class="col-md-1 col-1 col-sm-1 pad0 inLneBlk txtRight"
                                        (click)="removeStage(i)">
                                        <span class="lableBtnGray brdrRadius3" title="Remove Stage"
                                            style="padding: 2px 7px 2px;"><i class="fa fa-trash-o"></i></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        
                <div>
                    <span class="btn-darkGreen ng-scope brdrRadius3 btn-save"
                        style="padding: 2px 7px 1px; height: 30px; font-size: 14px;" (click)="saveStageFlow()">
                        <i class="fa fa-check" style="margin-right: 5px;"></i>Save
                    </span>
                </div>
            </div>
        </div>
        
    </div>
</ng-template>

<!-- Print Cofiguration-->
<ng-template #prntCnfgMdl let-modal>
    <!--Header-->
    <div class="modal-header" style="border-bottom: none; padding-bottom: 5px !important;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row">
                <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                    <h4 class="modal-title" style="line-height: 1.2;">
                        <span style="font-size: 22px;">BOM Print Configuration</span>
                    </h4>
                </div>
                <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close " title="Close" style="float: right; margin-top: 0px;" (click)="closePrntCnfModal()"></i>
                </div>
            </div>
        </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">
        <div class="col-md-12 col-12 col-sm-12 font13" style="padding: 0px 15px 2px; margin-bottom: 4px; display: flex; flex-direction: column; gap: 3px;">
            <div>
                <mat-checkbox class="example-margin" [(ngModel)]="prtCnfg.rates" tabindex="1">Rates
                </mat-checkbox>
            </div>
            <div>
                <mat-checkbox class="example-margin" [(ngModel)]="prtCnfg.totalPrice" tabindex="1">Total Cost
                </mat-checkbox>
            </div>
        </div> 
        <div class="col-md-12 col-xs-12 col-12" style="display: flex; padding: 5px 0px 15px 15px;">
            <div (click)="savePrntCnfg()">
                <span class="btn-save brdrRadius3" style="font-size: 14px !important; top: 1px;border-radius:25px;">
                    <i class="fa fa-check " style="margin-right:8px;"></i> Save 
                </span>
            </div>
        </div>
    </div>
</ng-template>

<ngx-spinner color="rgb(232, 132, 33)" size="default" type="ball-clip-rotate"></ngx-spinner>